import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { setPaymentCancel, setPaymentSuccess } from 'store/user-service/userSlice';

import { PaymentStatus } from 'core/enums/common';

export const PaymentResultPage = ({ status }: { status: PaymentStatus }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		if (status === PaymentStatus.success) {
			dispatch(setPaymentSuccess());
		}

		if (status === PaymentStatus.cancel) {
			dispatch(setPaymentCancel());
		}

		navigate('/');
	}, []);

	return <></>;
};
